import CryptoJS from "crypto-js";

const aesKey = "651cc172938d5b7799a23ac245e539a6";
const ivKey = "35e5cd2d684e5c65";

const decrypt = (data) => {
  let result = data;
  try {
    if (!data || typeof data !== "string") return;
    const key = CryptoJS.enc.Utf8.parse(aesKey);
    const iv = CryptoJS.enc.Utf8.parse(ivKey);
    let decrypted = CryptoJS.AES.decrypt(data, key, {
      iv: iv,
      mode: CryptoJS.mode.CBC,
      padding: CryptoJS.pad.Pkcs7,
    });
    const res = decrypted.toString(CryptoJS.enc.Utf8);
    result = JSON.parse(res);
  } catch {
    //
  } finally {
    // eslint-disable-next-line no-unsafe-finally
    return result;
  }
};
const encrypt = (data) => {
  let stringData = data;
  if (typeof data === "object") {
    try {
      stringData = JSON.stringify(data);
    } catch (error) {
      console.log("encrypt error:", error);
    }
  }
  const key = CryptoJS.enc.Utf8.parse(aesKey);
  const iv = CryptoJS.enc.Utf8.parse(ivKey);
  const encrypted = CryptoJS.AES.encrypt(stringData, key, {
    iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encrypted.toString();
};

export { decrypt, encrypt };
